<div class="pos-panel">
    <div class="pos-new-entity-header">
        <span class="material-icons cyan">restaurant</span>
        <span class="soc-panel-h">{{(editFlag ? 'MENU.EDIT_MENU_ITEM' : "MENU.NEW_MENU_ITEM") | translate}}</span>
    </div>
    <hr class="soc-panel-line"/>
    <form #f="ngForm" [formGroup]="form" class="soc-form-wrapper-gap-24" >
    <div class="pos-actions-wrapper" style="gap: 20px; overflow: auto;">
        <div class="w-50 soc-wrapper-gap-24-column h-100" >
            <div>
                <div class="mb-4 d-flex" style="gap: 20px;">
                    <img class="" style="border-radius: 8px; width: 96px; height: 96px;"
                        [src]="!menuItem.imageUrl? imagePath : menuItem.imageUrl ">
                    <div class="soc-wrapper-gap-24-column w-100">
                        <div class="pos-site-desc">
                            <span>{{'MENU_ITEM.MENU_ITEM_IMAGES' | translate }} </span>
                            <div pTooltip="MENU_ITEM_IMAGES" class="material-icons soc-info">info</div>
                        </div>
                        <label *ngIf="!imageFile" for="file-upload" class="soc-secondary-cyan-btn p-1" style=" cursor: pointer;"><span class="material-icons">add</span>{{'MENU_ITEM.UPLOAD_IMAGE' | translate }}</label>
                        <div *ngIf="imageFile" class="w-100 d-flex justify-content-between align-items-center">
                            <label class="soc-neutral-text-color "
                                style="display: inline-flex;max-width: 65%;overflow: hidden;white-space: nowrap;">
                                <i class="material-icons cyan me-1">image</i>
                                {{imageName}}
                                <span class="soc-neutral-50-text-color mx-1 "> {{imageSize}}</span>
                            </label>

                            <button for="file-upload" class="soc-secondary-cyan-btn p-1 float-end"
                                style=" cursor: pointer;">{{'MENU_ITEM.CHANGE_IMAGE'
                                | translate }}</button>
                        </div>
                        <input id="file-upload" (change)="onSelectFile($event)" type="file" />
                    </div>
                </div>

                <div class="soc-input-wrapper">
                    <label for="name" class="soc-input-lbl w-100 text-start">{{'MENU_ITEM.MENU_ITEM_NAME' | translate}}</label>
                    <div class=" soc-error-field-wrapper">
                        <span *ngIf="form.controls['name'].invalid && f.submitted" pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}" tooltipPosition="top" class="material-icons soc-error-icon">info</span>
                        <input formControlName="name" [ngClass]="{'soc-error-active': form.controls['name'].invalid && f.submitted}" class="soc-input-field soc-input-text" placeholder="{{'TYPE_HERE' | translate}}">
                    </div>
                </div>
                
            </div>
            <div class="soc-wrapper-gap-24-column">
                <div class="pos-site-desc">
                    <span>{{'MENU.CATEGORIZATION' | translate }} </span>
                    <div pTooltip="CATEGORIZATION" class="material-icons soc-info">info</div>
                </div>
                <div class="soc-wrapper-gap-24">
                    <div class="w-50 d-grid">
                        <label class="soc-input-lbl" style="height: 24px;">{{'MENU.CATEGORY'| translate}}</label>
                        <div class="soc-error-field-wrapper">
                            <span *ngIf="form.controls['category'].invalid && f.submitted" pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}" tooltipPosition="top" class="material-icons soc-error-icon">info</span>
                            <p-dropdown appendTo="body" [autoDisplayFirst]="false"
                                class="soc-dropdown soc-dropdown-search-separator soc-dropdown-btn-separator"
                                formControlName="category" appendTo="body"
                                [filter]="true" [options]="categories" optionLabel="name"
                                placeholder="{{'SELECT.CATEGORY' | translate }}" filterPlaceholder="{{'SEARCH' | translate }}"
                                (onChange)="onChangeCategory()"
                                [ngClass]="{'soc-error-active-dropdown': form.controls['category'].invalid && f.submitted}">
                            </p-dropdown>
                        </div>
                    </div>
                    <div class="w-50 d-grid">
                        <label class="soc-input-lbl soc-neutral-50-text-color" style="height: 24px;">{{'MENU.SUBCATEGORY'|
                            translate}}</label>
                        <p-dropdown appendTo="body" [autoDisplayFirst]="false" 
                            formControlName="subcategory" 
                            class="soc-dropdown soc-dropdown-search-separator soc-dropdown-btn-separator"
                            [filter]="true" [options]="subcategories" optionLabel="name"
                            placeholder="{{'SELECT.SUBCATEGORY' | translate }}"
                            filterPlaceholder="{{'SEARCH' | translate }}">
                        </p-dropdown>
                    </div>
                </div>
            </div>
            <div class="soc-wrapper-gap-24-column">
                <div class="pos-site-desc">
                    <span>{{'MENU.PRICING' | translate }} </span>
                    <div pTooltip="PRICING" class="material-icons soc-info">info</div>
                </div>
                <div class="soc-wrapper-gap-24">
                    <div class="w-50">
                        <div class="soc-addon-input-group">
                            <label for="price" class="soc-input-lbl w-100 text-start">{{'MENU.PRICE'| translate}}</label>
                            <div class="soc-error-field-wrapper w-100">
                                <span *ngIf="form.controls['price'].invalid && f.submitted" pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}" tooltipPosition="top" class="material-icons soc-error-icon">info</span>
                                <div class="p-inputgroup">
                                    <input formControlName="price" placeholder="{{'TYPE_HERE' | translate}}" class="soc-input-text w-100" type="text" [ngClass]="{'soc-error-active': form.controls['price'].invalid && f.submitted}" name="price" type="text">   
                                    <span class="p-inputgroup-addon soc-input-text"  style="width: 40px !important; "  [ngClass]="{'soc-error-active-addon': form.controls['price'].invalid && f.submitted}">{{currency ? currency.shortName : ''}}</span>      
                                </div>
                            </div>
                        </div>
                
                    </div>
                    <div class="w-50 d-grid">
                        <label class="soc-input-lbl" style="height: 24px;">{{'MENU.TAX_RATE'| translate}}</label>
                        <div class="soc-error-field-wrapper">
                            <span *ngIf="form.controls['taxRate'].invalid && f.submitted" pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}" tooltipPosition="top" class="material-icons soc-error-icon">info</span>
                            <p-dropdown formControlName="taxRate" appendTo="body" [autoDisplayFirst]="false"
                            class=" soc-dropdown soc-dropdown-search-separator soc-dropdown-btn-separator"
                            [filter]="true" [options]="taxRates" optionLabel="rate" 
                            placeholder="{{'SELECT.TAX_RATE' | translate }}" filterPlaceholder="{{'SEARCH' | translate }}"
                            [ngClass]="{'soc-error-active-dropdown': form.controls['taxRate'].invalid && f.submitted}">
                                <ng-template let-item pTemplate="selectedItem">
                                    <label>{{item.rate}}%</label>
                                </ng-template>
                                <ng-template let-object pTemplate="item">
                                    <label>{{object.rate}}%</label>
                                </ng-template>
                        </p-dropdown>
                    </div>                
                    </div>
                </div>
            </div>
        </div>
        <div class="w-50 h-100 soc-wrapper-gap-24-column">
            <div class="pos-site-desc">
                <span>{{'MENU.INGREDIENTS' | translate }} </span>
                <div pTooltip="ALL INGREDIENTS" class="material-icons soc-info">info</div>
            </div>
            <p-table class="soc-borderless-cyan-table soc-editable-table" [value]="ingredients.controls" [responsive]="true" [scrollable]="true" scrollHeight="calc(100vh - 434px)">
                <ng-template pTemplate="header">
                    <tr>
                        <th [style.min-width]="'240px'">{{'MENU.INVENORY_ITEM' | translate }}</th>
                        <th>{{'MENU.QUANTITY' | translate }}</th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
                    <ng-container formArrayName="ingredients">
                        <tr [formGroupName]="rowIndex">
                            <td [style.min-width]="'240px'">
                                <div class="soc-error-field-wrapper w-100">
                                    <span *ngIf="getIngredientControls(rowIndex).controls['stockItem'].invalid && f.submitted" pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}"  tooltipPosition="top" class="material-icons soc-error-icon" >info</span>
                                    <p-dropdown [autoDisplayFirst]="false" appendTo="body"
                                        class="soc-dropdown soc-dropdown-search-separator soc-dropdown-btn-separator"
                                        [ngClass]="{'soc-error-active-dropdown': getIngredientControls(rowIndex).controls['stockItem'].invalid && f.submitted }" 
                                        [filter]="true" [options]="stockItemsList" optionLabel="name"
                                        formControlName="stockItem"
                                        placeholder="{{'SELECT.ITEM' | translate }}"
                                        filterPlaceholder="{{'SEARCH' | translate }}">
                                        <ng-template pTemplate="footer">
                                            <div class="footer-wrapper">
                                                <button class="soc-secondary-cyan-btn w-100"
                                                    (click)="addNewStockItem()"><span
                                                        class="material-icons">add</span>{{'MENU.ADD_NEW_ITEM'
                                                    | translate }}</button>
                                            </div>
                                        </ng-template>
                                    </p-dropdown>
                                </div>
                            </td>
                            <td>
                                <div class="soc-addon-input-group w-100">
                                    <div class="soc-error-field-wrapper w-100">
                                        <span *ngIf="getIngredientControls(rowIndex).controls['quantity'].invalid && f.submitted" pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}" tooltipPosition="top" class="material-icons soc-error-icon">info</span>
                                        <div class="p-inputgroup">
                                            <input formControlName="quantity" placeholder="{{'TYPE_HERE' | translate}}" class="soc-input-text" type="text" [ngClass]="{'soc-error-active': getIngredientControls(rowIndex).controls['quantity'].invalid && f.submitted}" type="text">   
                                            <span class="p-inputgroup-addon soc-input-text"  style="width: 40px !important;" style="width: 40px !important; " [ngClass]="{'soc-error-active-addon': getIngredientControls(rowIndex).controls['quantity'].invalid && f.submitted}">{{getIngredientControls(rowIndex).controls['stockItem'].value && getIngredientControls(rowIndex).controls['stockItem'].value != '' ? (getIngredientControls(rowIndex).controls['stockItem'].value['unitType'] | unitShortener | lowercase) : '-'}}</span>      
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <button class="soc-secondary-cyan-btn" type="button" (click)="onDeleteRow(rowIndex);"><span
                                    class="material-icons-round">close</span></button>
                            </td>
                        </tr>
                    </ng-container>
                </ng-template>
                <ng-template pTemplate="footer">
                    <div class="footer-wrapper">
                        <button class="soc-secondary-cyan-btn w-100" type="button" (click)="addNewRow()"><span
                                class="material-icons">add</span>{{'MENU.ADD_ITEM' | translate }}</button>
                    </div>
                </ng-template>
            </p-table>
            <hr class="soc-panel-line-cyan" />
        </div>
    </div>
    <hr class="soc-panel-line" />
    <div class="soc-wrapper-gap-12 justify-content-end">
        <button class="soc-secondary-cyan-btn" type="button" (click)="cancel()">{{'CANCEL' | translate }}</button>
        <button class="soc-basic-cyan-btn" type="submit"
            (click)="editFlag? editMenuItem(imageFile) : addMenuItem(imageFile) ">{{(editFlag ?
            'SAVE_CHANGES' : 'MENU.CREATE_MENU_ITEM')| translate}}</button>
    </div>
    </form>
</div>